import React, {Component} from 'react';
import {Translation} from 'react-i18next';
import {Button, Card, Col, Row, Space, Spin} from 'antd';
import {LoadingOutlined, PlusCircleOutlined} from '@ant-design/icons';

import RegionList from '../containers/RegionListContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import {pathTo} from '../../../../Routes';
import Config from '../../../../../../Config';
import QueryString from '../../../../../../lib/QueryString';
import Logger from '../../../../../../lib/Logger';

class RegionScreen extends Component {

  static defaultProps = {
    limit: Config.get('DEFAULT_LIST_LENGTH', 10),
    isLoading: true,
  }

  scrollToTop = () => {
    Logger.log('debug', `RegionScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {

    const loadingIcon = <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />;
    const page = parseInt(this.props.match.params.page ? this.props.match.params.page : 1);
    const {order, ...filter} = QueryString.parse(this.props.location.search);
    return (
      <Translation>{(t) => 
        <div>

          <DocumentHead title={t('locations_region_route_list')} />

          <Row>
            <Col span={24}>
              <Card
                title={
                  <Space size={10}>
                    {t('region_list_title')}
                    <Button
                      size="small"
                      icon={<PlusCircleOutlined />}
                      onClick={e => this.props.history.push(pathTo('RegionAddScreen'))}
                    >
                      {t('action_create')}
                    </Button>
                  </Space>
                }
                extra={this.props.isLoading ? loadingIcon : null}
              >
                <RegionList
                  key={page}
                  component="RegionScreen"
                  page={page}
                  limit={this.props.limit}
                  order={order || 'id.asc'}
                  filter={filter}
                />
              </Card>
            </Col>
          </Row>

        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RegionScreen;

Logger.log('silly', `RegionScreen loaded.`);
